import { render, staticRenderFns } from "./reTutor.vue?vue&type=template&id=5aaffbc7&scoped=true&"
import script from "./reTutor.vue?vue&type=script&lang=js&"
export * from "./reTutor.vue?vue&type=script&lang=js&"
import style0 from "./reTutor.vue?vue&type=style&index=0&id=5aaffbc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaffbc7",
  null
  
)

export default component.exports